let servdefinitions = {

    "modalidad": [
        { value: "CAE", name: "CAE" },
        { value: "CAI", name: "CAI" },
        { value: "CAEA", name: "CAEA" }
    ],

    "tipocomprobante": [
        { value: '1', name: '1 - Facturas A' },
        { value: '2', name: '2 - Notas de Debito A' },
        { value: '3', name: '3 - Notas de Credito A' },
        { value: '4', name: '4 - Recibos A' },
        { value: '5', name: '5 - Notas de Venta al contado A' },
        { value: '6', name: '6 - Facturas B' },
        { value: '7', name: '7 - Notas de Debito B' },
        { value: '8', name: '8 - Notas de Credito B' },
        { value: '9', name: '9 - Recibos B' },
        { value: '10', name: '10 - Notas de Venta al contado B' },
        { value: '11', name: '11 - FACTURAS C' },
        { value: '12', name: '12 - NOTAS DE DEBITO C' },
        { value: '13', name: '13 - NOTAS DE CREDITO C' },
        { value: '15', name: '15 - RECIBOS C' },
        { value: '19', name: '19 - Facturas de Exportacion' },
        { value: '20', name: '20 - N. Deb. p/operac. con el exterior' },
        { value: '21', name: '21 - N. Cre. p/operac. con el exterior' },
        { value: '22', name: '22 - Fac. Perm. Export. Simp. - Dto.855/97' },
        { value: '30', name: '30 - Cbtes. compra de bienes usados' },
        { value: '31', name: '31 - Mandato/Consignación' },
        { value: '32', name: '32 - COMPROBANTES DE COMPRA DE MATERIALES A RECICLAR PROVENIENTES' },
        { value: '34', name: '34 - Cbtes. A del Anexo I, Apartado A,inc.f),R.G.Nro. 1415' },
        { value: '35', name: '35 - Cbtes. B del Anexo I,Apartado A,inc. f),R.G. Nro. 1415' },
        { value: '37', name: '37 - N. Deb/doc. equiv. que cumplan con R.G.Nro. 1415' },
        { value: '38', name: '38 - N. Cred/doc. equiv. que cumplan con R.G.Nro. 1415' },
        { value: '39', name: '39 - Otros comprobantes A que cumplan con R.G.Nro. 1415' },
        { value: '40', name: '40 - Otros comprobantes B que cumplan con R.G.Nro. 1415' },
        { value: '41', name: '41 - OTROS COMPROBANTES C QUE CUMPLAN CON LA R.G. N° 1415' },
        { value: '51', name: '51 - Facturas M' },
        { value: '52', name: '52 - Notas de Debito M' },
        { value: '53', name: '53 - Notas de credito M' },
        { value: '54', name: '54 - Recibo M' },
        { value: '55', name: '55 - Notas de Venta al contado M' },
        { value: '56', name: '56 - Comprobantes M del anexo I, Apartado A,inc. f)R.G.Nro.1415' },
        { value: '57', name: '57 - Otros Comprobantes M que cumplan con la R.G. Nro. 1415' },
        { value: '58', name: '58 - Cuenta de Venta y Liquido producto M' },
        { value: '59', name: '59 - Liquidacion M' },
        { value: '60', name: '60 - Cta de Vta y Liquido prod. A' },
        { value: '61', name: '61 - Cta de Vta y Liquido prod. B' },
        { value: '63', name: '63 - Liquidacion A' },
        { value: '64', name: '64 - Liquidacion B' },
        { value: '70', name: '70 - Recibo de Factura de Credito R' },
        { value: '91', name: '91 - Remito R' },
        { value: '49', name: '49 - Comprobante de Compra de Bienes Usados' }
    ],

    "tipodocumento": [
        { value: '80', name: '80 - CUIT' },
        { value: '86', name: '86 - CUIL' },
        { value: '87', name: '87 - CDI' },
        { value: '89', name: '89 - LE' },
        { value: '90', name: '90 - LC' },
        { value: '91', name: '91 - CI Extranjera' },
        { value: '92', name: '92 - en trámite' },
        { value: '93', name: '93 - Acta Nacimiento' },
        { value: '95', name: '95 - CI Bs. As. RNP' },
        { value: '96', name: '96 - DNI' },
        { value: '94', name: '94 - Pasaporte' },
        { value: '00', name: '00 - CI Policía Federal' },
        { value: '01', name: '01 - CI Buenos Aires' },
        { value: '02', name: '02 - CI Catamarca' },
        { value: '03', name: '03 - CI Córdoba' },
        { value: '04', name: '04 - CI Corrientes' },
        { value: '05', name: '05 - CI Entre Ríos' },
        { value: '06', name: '06 - CI Jujuy' },
        { value: '07', name: '07 - CI Mendoza' },
        { value: '08', name: '08 - CI La Rioja' },
        { value: '09', name: '09 - CI Salta' },
        { value: '10', name: '10 - CI San Juan' },
        { value: '11', name: '11 - CI San Luis' },
        { value: '12', name: '12 - CI Santa Fe' },
        { value: '13', name: '13 - CI Santiago del Estero' },
        { value: '14', name: '14 - CI Tucumán' },
        { value: '16', name: '16 - CI Chaco' },
        { value: '17', name: '17 - CI Chubut' },
        { value: '18', name: '18 - CI Formosa' },
        { value: '19', name: '19 - CI Misiones' },
        { value: '20', name: '20 - CI Neuquén' },
        { value: '21', name: '21 - CI La Pampa' },
        { value: '22', name: '22 - CI Río Negro' },
        { value: '23', name: '23 - CI Santa Cruz' },
        { value: '24', name: '24 - CI Tierra del Fuego' },
        { value: '99', name: '99 - Doc. (Otro)' }
    ]

}

export default servdefinitions
